import { FormGroup, NumericInput } from '@blueprintjs/core'

import type { WeldingConfig } from '../api'

/**
 * Reusable WPS editor used inside PropertyManager forms.
 *
 * Owns no state — reads `wps` and calls `onChange` with the whole
 * updated snapshot. That makes undo (via Zustand replace) trivial.
 */
export function WeldingParams({
  wps,
  onChange,
}: {
  wps: WeldingConfig
  onChange: (wps: WeldingConfig) => void
}) {
  const bind = (k: keyof WeldingConfig) => ({
    value: wps[k] as number,
    onValueChange: (v: number) => onChange({ ...wps, [k]: v }),
  })

  return (
    <div className="wps-grid">
      <FormGroup label="Travel (mm/min)">
        <NumericInput {...bind('travel_mm_min')} stepSize={10} />
      </FormGroup>
      <FormGroup label="Voltage (V)">
        <NumericInput {...bind('voltage_v')} stepSize={0.5} />
      </FormGroup>
      <FormGroup label="Current (A)">
        <NumericInput {...bind('current_a')} stepSize={10} />
      </FormGroup>
      <FormGroup label="Wire feed (m/min)">
        <NumericInput {...bind('wire_feed_m_min')} stepSize={0.5} />
      </FormGroup>
      <FormGroup label="Wire Ø (mm)">
        <NumericInput {...bind('wire_dia_mm')} stepSize={0.1} minorStepSize={0.01} />
      </FormGroup>
      <FormGroup label="Stickout (mm)">
        <NumericInput {...bind('stickout_mm')} stepSize={1} />
      </FormGroup>
      <FormGroup label="Bead width (mm)">
        <NumericInput {...bind('bead_width_mm')} stepSize={0.5} />
      </FormGroup>
      <FormGroup label="Bead overlap (%)">
        <NumericInput {...bind('bead_overlap_pct')} stepSize={5} min={0} max={95} />
      </FormGroup>
      <FormGroup label="Torch offset (mm)">
        <NumericInput {...bind('torch_offset_mm')} stepSize={0.5} />
      </FormGroup>
      <FormGroup label="Samples / rev">
        <NumericInput {...bind('samples_per_rev')} stepSize={6} min={6} />
      </FormGroup>
    </div>
  )
}
